import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { LoopBackConfig } from '../../shared/sdk/lb.config';
import { Platform } from 'ionic-angular/platform/platform';
import { File } from '@ionic-native/file';
import { NestApiProvider } from '../../shared/nestjs/nest-api';
import { SFGOAuthService } from '../sfgoauth.service/sfgoauth.service';
import { AppPreferences } from '../../shared/local/app-preferences.local';
import { GDAuthInterface } from '../../model/gd-auth';

/*
  Generated class for the AvatarProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/

export interface ResponseStoragePath {
  urlUpload: string,
  urlDownload: string
}
@Injectable()
export class StoragePathProvider {
  private storagePath = {
    storageAttendance: 'StorageAttendances',
    storagePost: 'StoragePosts',
    storageProfile: 'StorageProfiles',
    storageClaim: 'StorageClaims',
    storageActivity: 'StorageActivities',
    storageAttachmentfile: 'StorageAttachmentFiles',
    storageItcs: 'storageItcs',
    Panic: 'Panic',
    storageEmergency: 'storageEmergency',
    storageChat: 'StorageChat',
    storageEducation: 'storageEducation',
    storageFaceBase: 'storageFaceBase',
  }
  private folderDownload = 'Download/GreatDayHr/'
  constructor(
    public storage: Storage,
    public platform: Platform,
    public file: File,
    public nestApiProvider: NestApiProvider,
    private sfgoAuthService: SFGOAuthService,
    private nestApi: NestApiProvider,
    private appPreferences: AppPreferences
  ) {

  }

  getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }

  async getUrlStorage(storagePath: string, funcUpload: string, funcDownload: string, auth: GDAuthInterface, userId?: any): Promise<ResponseStoragePath> {
    const isGopathNew = await this.sfgoAuthService.isGopathNew();
    const loopbackPath: string = LoopBackConfig.getPath();
    const storageName = userId !== null ? auth.companyCode.toLowerCase() + '_' + userId : auth.companyCode.toLowerCase();

    console.log('storageName', storageName, userId);

    let url: ResponseStoragePath = {
      urlUpload: null,
      urlDownload: null
    }

    if (isGopathNew) {
      /** get object key by value */
      storagePath = this.getKeyByValue(this.storagePath, storagePath);

      if (storagePath != 'storageProfile' && storagePath != 'storageClaim') {
        url.urlUpload = this.nestApi.gopathNew + `/storage/upload/${storagePath}/${storageName}?`;
        url.urlDownload = this.nestApi.gopathNew + `/storage/${storagePath}/${storageName}?fileName=`;
      } else {
        url.urlUpload = this.nestApi.gopathNew + `/storage/upload/${storagePath}/${storageName}?`;
        url.urlDownload = this.nestApi.gopathNew + `/storage/${storagePath}/${storageName}?fileName=`;
      }
    } else {
      url.urlUpload = loopbackPath + `/api/${storagePath}/${storageName}/${funcUpload}?`;
      url.urlDownload = loopbackPath + `/api/${storagePath}/${storageName}/${funcDownload}/`;
    }

    return url;
  }

  getUrlDownload(urlDownload: string, fileName: string) {
    /** handle url download nest api */
    const urlPath = urlDownload + fileName;
    return urlPath;
  }

  async getStorageAttendance(auth: GDAuthInterface, userId?: any): Promise<ResponseStoragePath> {
    return await this.getUrlStorage(this.storagePath.storageAttendance, 'upload', 'download', auth, userId);
  }

  async getStorageAttachmentFile(auth: GDAuthInterface, userId?: any): Promise<ResponseStoragePath> {
    return await this.getUrlStorage(this.storagePath.storageAttachmentfile, 'upload', 'download', auth, userId);
  }

  async getStoragePanic(auth: GDAuthInterface, userId?: any): Promise<ResponseStoragePath> {
    return await this.getUrlStorage(this.storagePath.Panic, 'uploadPhotos', 'download', auth, userId);
  }

  async getStorageEmergency(): Promise<ResponseStoragePath> {
    const SFGoAuth = await this.appPreferences.getAuth();
    return await this.getUrlStorage(this.storagePath.storageEmergency, 'upload', 'download', SFGoAuth, SFGoAuth.userId);
  }

  async getStorageFaceBloc(): Promise<ResponseStoragePath> {
    const SFGoAuth = await this.appPreferences.getAuth();
    return await this.getUrlStorage(this.storagePath.storageFaceBase, 'upload', 'download', SFGoAuth, null);
  }

  async getStorageItcs(auth: GDAuthInterface, userId?: any): Promise<ResponseStoragePath> {
    return await this.getUrlStorage(this.storagePath.storageItcs, 'uploadPhotos', 'download', auth, userId);
  }

  async getStorageEducation(auth: GDAuthInterface, userId?: any): Promise<ResponseStoragePath> {
    console.log('getStorageEducation', auth, userId);
    return await this.getUrlStorage(this.storagePath.storageEducation, 'upload', 'download', auth, userId);
  }

  getStorageChat(params): Promise<any> {
    return this.storage.get('SFGoAuth').then(response => {
      const auth = JSON.parse(response);
      const result = {
        urlUpload: null,
        urlDownload: null,
        urlUploadProfile: null,
        urlDownloadProfile: null
      }

      const storageName = auth.companyCode.toLowerCase() + '_' + params.roomId;
      const storageNameProfileImage = auth.companyCode.toLowerCase() + '_profile_image';

      result.urlUpload = this.nestApi.gopathNew + `/storage/upload/storageChat/${storageName}?`;
      result.urlDownload = this.nestApi.gopathNew + `/storage/storageChat/${storageName}?fileName=`;
      result.urlUploadProfile = this.nestApi.gopathNew + `/storage/storageChat/${storageNameProfileImage}? `;
      result.urlDownloadProfile = this.nestApi.gopathNew + `/storage/storageChat/${storageNameProfileImage}?fileName=`;
      return Promise.resolve(result);
      // return Promise.resolve({
      //   urlUpload: loopbackPath + '/api/StorageChats/' + storageName + '/upload?',
      //   urlUploadProfile: loopbackPath + '/api/StorageChats/' + storageNameProfileImage + '/upload?',
      //   urlDownload: this.nestApi.gopathNew + '/storage/' + storageName + '/download/'
      // });
    });
  }

  getStorageClaim(): Promise<any> {
    let loopbackPath: string = LoopBackConfig.getPath();
    return this.storage.get('SFGoAuth').then(hasil => {
      let storageName = (JSON.parse(hasil).companyCode).toLowerCase() + '_' + JSON.parse(hasil).userId;
      return Promise.resolve({
        urlUpload: loopbackPath + '/api/StorageClaims/' + storageName + '/upload?',
        urlDownload: loopbackPath + '/api/StorageClaims/' + storageName + '/download/'
      });
    });
  }

  getStorageClaimNest(data?): Promise<any> {
    return this.storage.get('SFGoAuth').then(hasil => {
      console.log(`hasil`, hasil);
      let storageName: any;
      if (data) {
        storageName = (JSON.parse(hasil).companyCode).toLowerCase() + '_' + data;
      } else {
        storageName = (JSON.parse(hasil).companyCode).toLowerCase() + '_' + JSON.parse(hasil).userId;
      }
      return Promise.resolve({
        urlUpload: this.nestApi.gopathNew + '/storage/upload/storageClaim/' + storageName + '?',
        urlDownload: this.nestApi.gopathNew + '/storage/storageClaim/' + storageName + '?fileName=',
      });
    });
  }

  getStorageClaimNestPdf(data): Promise<any> {
    console.log('data', data);
    return this.storage.get('SFGoAuth').then(hasil => {
      console.log(`hasil`, hasil);
      let storageName = (JSON.parse(hasil).companyCode).toLowerCase() + '_' + data;
      return Promise.resolve({
        urlDownload: this.nestApi.gopathNew + '/storage/storageClaim/' + storageName + '?fileName=',
      });
    });
  }

  async getStorageActivityRecord(): Promise<{ urlUpload: any, urlDownload: any }> {
    try {
      // let loopbackPath: string = LoopBackConfig.getPath();
      const auth = await this.storage.get('SFGoAuth');
      let storageName = (JSON.parse(auth).companyCode).toLowerCase();
      return Promise.resolve({
        urlUpload: this.nestApi.gopathNew + '/storage/upload/storageActivityRecord/' + storageName + '?',
        urlDownload: this.nestApi.gopathNew + '/storage/storageActivityRecord/' + storageName
      });
    } catch (error) {
      return Promise.resolve({
        urlUpload: '',
        urlDownload: ''
      });
    }
  }

  // getStoragePost(): Promise<{ urlUpload: string, urlDownload: string }> {
  //   let loopbackPath: string = LoopBackConfig.getPath();
  //   return this.storage.get('SFGoAuth').then(hasil => {
  //     let storageName = (JSON.parse(hasil).companyCode).toLowerCase() + '_' + JSON.parse(hasil).userId;
  //     return Promise.resolve({
  //       urlUpload: loopbackPath + '/api/StoragePosts/' + storageName + '/upload?',
  //       urlDownload: loopbackPath + '/api/StoragePosts/' + storageName + '/download/'
  //     });
  //   });
  // }

  async getStoragePost(): Promise<ResponseStoragePath> {
    const SFGoAuth = await this.appPreferences.getAuth();
    return await this.getUrlStorage(this.storagePath.storagePost, 'upload', 'download', SFGoAuth, SFGoAuth.userId);
  }

  sfGetImage(url: string) {
    return this.nestApi.gopathNew + `/storage/sfgetimage?url=${encodeURIComponent(url)}`;
  }

  getStorageAttendanceCustom(params): Promise<any> {
    let loopbackPath: string = LoopBackConfig.getPath();
    return this.storage.get('SFGoAuth').then(hasil => {
      let storageName = (JSON.parse(hasil).companyCode).toLowerCase() + '_' + params.userId;
      return Promise.resolve({
        urlUpload: loopbackPath + '/api/StorageAttendances/' + storageName + '/upload?',
        urlDownload: loopbackPath + '/api/StorageAttendances/' + storageName + '/download/'
      });
    });
  }

  getStorageProfile(): Promise<any> {
    let loopbackPath: string = LoopBackConfig.getPath();
    return this.storage.get('SFGoAuth').then(hasil => {
      let SFGoAuth = JSON.parse(hasil);
      let storageName = (SFGoAuth.companyCode).toLowerCase() + '_' + SFGoAuth.userId;
      let photopath = SFGoAuth.empphotopath || null;

      if (photopath) {
        try {
          return Promise.resolve({
            urlUpload: encodeURI('https://sfcola.dataon.com/sf6help/file.cfm?key=c0ab72be03a67dccb1b0ef64eb16ea07'),
            urlDownload: photopath
          });
        } catch (err) {
          return Promise.reject(err);
        }
      } else {
        try {
          return Promise.resolve({
            urlUpload: loopbackPath + '/api/StorageProfiles/' + storageName + '/upload?',
            urlDownload: loopbackPath + '/api/StorageProfiles/' + storageName + '/download/'
          });
        } catch (err) {
          return Promise.reject(err);
        }
      }
    });
  }

  getStorageProfileCustom(userId): Promise<{ urlUpload: string, urlDownload: string }> {
    return this.storage.get('SFGoAuth').then(async (hasil) => {
      let SFGoAuth = JSON.parse(hasil);
      let photopath = SFGoAuth.empphotopath || null;

      if (photopath) {
        try {
          if (await this.nestApi.isGoPathNewExist()) {
            return Promise.resolve({
              urlUpload: this.nestApi.gopathNew + '/storage/uploadSf6',
              urlDownload: photopath
            });
          } else {
            return Promise.resolve({
              urlUpload: encodeURI('https://sfcola.dataon.com/sf6help/file.cfm?key=c0ab72be03a67dccb1b0ef64eb16ea07'),
              urlDownload: photopath
            });
          }
        } catch (err) {
          return Promise.reject(err);
        }
      } else {
        try {
          const storage = await this.getUrlStorage(this.storagePath.storageProfile, 'upload', 'download', SFGoAuth, userId);
          return Promise.resolve(storage);
        } catch (err) {
          return Promise.reject(err);
        }
      }
    });
  }

  getStorageCompanyProfile(): Promise<any> {
    let loopbackPath: string = LoopBackConfig.getPath();
    return this.storage.get('SFGoAuth').then(hasil => {
      let SFGoAuth = JSON.parse(hasil);
      let storageName = (SFGoAuth.companyCode).toLowerCase();
      let companyphotopath = SFGoAuth.companyphotopath || null;

      if (companyphotopath) {
        try {
          return Promise.resolve({
            urlUpload: encodeURI('https://sfcola.dataon.com/sf6help/file.cfm?key=c0ab72be03a67dccb1b0ef64eb16ea07'),
            urlDownload: companyphotopath
          });
        } catch (err) {
          return Promise.reject(err);
        }
      } else {
        try {
          return Promise.resolve({
            urlUpload: this.nestApi.gopathNew + '/storage/storageCompanyProfile/' + storageName + '/upload?access_token=' + SFGoAuth.id,
            urlDownload: this.nestApi.gopathNew + '/storage/storageCompanyProfile/' + storageName + '?fileName='
          });
        } catch (err) {
          return Promise.reject(err);
        }
      }
    });
  }

  getStoragePayroll(): Promise<any> {
    let loopbackPath: string = LoopBackConfig.getPath();
    return this.storage.get('SFGoAuth').then(hasil => {
      // let storageName = (JSON.parse(hasil).companyCode).toLowerCase() + '_' + JSON.parse(hasil).userId;
      return Promise.resolve({
        urlUpload: loopbackPath + '/api/StoragePayrolls/upload_component/upload?',
        urlDownload: loopbackPath + '/api/StoragePayrolls/upload_component/download/'
      });
    });
  }

  getStorageInvitation(): Promise<any> {
    let loopbackPath: string = LoopBackConfig.getPath();
    return this.storage.get('SFGoAuth').then(hasil => {
      let storageName = (JSON.parse(hasil).companyCode).toLowerCase();
      return Promise.resolve({
        urlUpload: loopbackPath + '/api/StorageInvitations/' + storageName + '/upload',
        urlDownload: loopbackPath + '/api/StorageInvitations/' + storageName + '/download/'
      });
    });
  }

  getStorageCustom(container): Promise<any> {
    let loopbackPath: string = LoopBackConfig.getPath();
    return this.storage.get('SFGoAuth').then(hasil => {
      let storageName = (JSON.parse(hasil).companyCode).toLowerCase();
      return Promise.resolve({
        urlUpload: loopbackPath + '/api/' + container + '/' + storageName + '/upload',
        urlDownload: loopbackPath + '/api/' + container + '/' + storageName + '/download/'
      });
    });
  }

  getStoragePartner(): Promise<any> {
    let loopbackPath: string = LoopBackConfig.getPath();
    return this.storage.get('SFGoAuth').then(hasil => {
      let storageName = (JSON.parse(hasil).companyCode).toLowerCase();
      return Promise.resolve({
        urlUpload: loopbackPath + '/api/StoragePartners/' + storageName + '/uploadFile?',
        urlDownload: loopbackPath + '/api/StoragePartners/' + storageName + '/downloadFile/'
      });
    });
  }

  getStorageBirthday(): Promise<any> {
    let loopbackPath: string = LoopBackConfig.getPath();
    return this.storage.get('SFGoAuth').then(hasil => {
      let storageName = (JSON.parse(hasil).companyCode).toLowerCase();
      return Promise.resolve({
        urlUpload: loopbackPath + '/api/StorageBirthdays/' + storageName + '/upload?',
        urlDownload: loopbackPath + '/api/StorageBirthdays/' + storageName + '/download/'
      });
    });
  }

  getStorageUploadMember(): Promise<any> {
    let loopbackPath: string = LoopBackConfig.getPath();
    return this.storage.get('SFGoAuth').then(hasil => {
      let storageName = (JSON.parse(hasil).companyCode).toLowerCase();
      return Promise.resolve({
        urlUpload: loopbackPath + '/api/StorageDataEmployees/' + storageName + '/uploadFile?',
        urlDownload: loopbackPath + '/api/EmployeeDataUpdate/downloadTemplate?&',
      });
    });
  }

  getStoragePolicyAnnouncement(): Promise<any> {
    const loopbackPath: string = LoopBackConfig.getPath();
    return this.storage.get('SFGoAuth').then(hasil => {
      const storageName = (JSON.parse(hasil).companyCode).toLowerCase();
      return Promise.resolve({
        urlUpload: loopbackPath + '/api/StoragePolicyAnnouncements/' + storageName + '/uploadFile?',
        urlDownload: loopbackPath + '/api/StoragePolicyAnnouncements/' + storageName + '/downloadFile/',
      });
    });
  }

  getStoragePolicyAnnouncementNew(): Promise<any> {
    const nestPath: string = this.nestApiProvider.getPath()
    return this.storage.get('SFGoAuth').then(hasil => {
      const storageName = (JSON.parse(hasil).companyCode).toLowerCase();
      return Promise.resolve({
        urlDownload: nestPath + '/storage/storagePolicyAnnouncement/' + storageName,
      });
    });
  }

  /**
   * 
   * @param container contoh container: logo, dll.
   * @returns 
   */
  getStorageIDCard(container?: string): Promise<any> {
    let loopbackPath: string = LoopBackConfig.getPath();
    // const storageName = (JSON.parse(hasil).companyCode).toLowerCase() + '_' + JSON.parse(hasil).userId;
    return Promise.resolve({
      urlUpload: this.nestApi.gopathNew + `/storage/upload/storageIdCard/${container}`,
      urlDownload: loopbackPath + '/api/StorageIdCards/logo/downloadFile/'
    });
  }

  getStorageEmpCareer(): Promise<any> {
    let loopbackPath: string = LoopBackConfig.getPath();
    return this.storage.get('SFGoAuth').then(hasil => {
      let storageName = (JSON.parse(hasil).companyCode).toLowerCase();
      return Promise.resolve({
        urlUpload: loopbackPath + '/api/StorageDataCareers/' + storageName + '/uploadFile?',
        urlDownload: loopbackPath + '/api/Employeecareer/downloadTemplate?' + '&params=%7B%22isCordova%22%3A0%7D',
      });
    });
  }

  getStorageFamilies(): Promise<any> {
    let loopbackPath: string = LoopBackConfig.getPath();
    return this.storage.get('SFGoAuth').then(hasil => {
      let storageName = (JSON.parse(hasil).companyCode).toLowerCase() + '_' + JSON.parse(hasil).userId;
      return Promise.resolve({
        urlUpload: loopbackPath + `/api/StorageDocumentFamilies/${storageName}/uploadFile?`,
        urlDownload: loopbackPath + `/api/StorageDocumentFamilies/${storageName}/download/`
      });
    });
  }

  // getStorageEducation(): Promise<any> {
  //   let loopbackPath: string = LoopBackConfig.getPath();
  //   return this.storage.get('SFGoAuth').then(hasil => {
  //     let storageName = (JSON.parse(hasil).companyCode).toLowerCase() + '_' + JSON.parse(hasil).userId;
  //     return Promise.resolve({
  //       urlUpload: loopbackPath + `/api/StorageEducations/${storageName}/uploadFile?`,
  //       urlDownload: loopbackPath + `/api/StorageEducations/${storageName}/download/`
  //     });
  //   });
  // }

  setStorageNativeDownload(fileName: string = ''): Promise<any> {
    return new Promise((resolve) => {
      let path = '';
      if (this.platform.is('android')) {
        path = this.file.externalCacheDirectory + fileName;
      }
      else if (this.platform.is('ios')) {
        path = this.file.documentsDirectory + this.folderDownload + fileName;
      }
      resolve(path);
    })
  }

  getPathFolderDownload(fileName: string = '') {
    let path = '';
    if (this.platform.is('android')) {
      path = this.file.externalRootDirectory + this.folderDownload + fileName;
    }
    else if (this.platform.is('ios')) {
      path = this.file.documentsDirectory + this.folderDownload + fileName;
    }

    return path;
  }

  getStoragePagebuilder(): Promise<any> {
    let loopbackPath: string = LoopBackConfig.getPath();
    return this.storage.get('SFGoAuth').then(hasil => {
      let storageName = (JSON.parse(hasil).companyCode).toLowerCase();
      return Promise.resolve({
        urlUpload: loopbackPath + '/api/StoragePagebuilders/' + storageName + '/upload?',
        urlDownload: loopbackPath + '/api/StoragePagebuilders/' + storageName + '/download/'
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/storage-path/storage-path.ts